module.exports = __webpack_public_path__ + "static/media/SealCheckRounded.95296223.svg";